import { render, staticRenderFns } from "./ProductDashboardReinsurances.vue?vue&type=template&id=1db1743c&scoped=true"
import script from "./ProductDashboardReinsurances.vue?vue&type=script&lang=js"
export * from "./ProductDashboardReinsurances.vue?vue&type=script&lang=js"
import style0 from "./ProductDashboardReinsurances.vue?vue&type=style&index=0&id=1db1743c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db1743c",
  null
  
)

export default component.exports